<template>
  <v-container class="person-desc none-fluid">
    <v-row class="mx-auto person-content" justify="space-between">
      <v-col cols="12" md="3" class="people-detail-intro text-center">
        <img :src="photo" :alt="name" class="people-dialog-image" />
        <v-btn
          v-if="website"
          text
          color="rgb(153, 27, 30)"
          target="_blank"
          :href="website"
          >Personal Website</v-btn
        >
      </v-col>
      <v-col cols="12" lg="9">
        <h1 class="person-modal-name">{{ name }}</h1>
        <h2 class="person-modal-title">{{ title }}</h2>
<!--        <p v-html="description"></p>-->
        <div v-if="projects">
          <br />
          <h3>Projects:</h3>
          <ul>
            <li v-for="proj in projects" :key="proj">{{ proj }}</li>
          </ul>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getPersonById } from "../../service/about/people";

export default {
  data() {
    return {
      name: "",
      description: "",
      photo: "",
      title: "",
      website: "",
      projects: [],
    };
  },
  mounted() {
    const id = this.$route.query.id;
    getPersonById(id)
      .then((data) => {
        const { name, description, photo, title, website, projects } = data;
        this.name = name;
        this.description = description;
        this.photo = photo;
        this.title = title;
        this.website = website;
        this.projects = projects;
      })
      .catch((err) => {
        console.error(err.message);
      });

    // to top
    const options = {
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("body", options);
  },
};
</script>

<style lang="scss">
.person-desc {
  .person-content {
    .people-dialog-image {
      margin-top: 10px;
      width: 100%;
    }

    h2 {
      color: gray;
      margin-bottom: 20px;
    }
  }
}

/**
 * following are responsive support
 */
@media (max-width: 420px) {
  .person-desc {
    .person-content {
      .people-detail-intro {
        text-align: center;
      }
    }
  }
}
</style>
